export enum BookingToolTypes {
  SAVE_BOOKING_TOOL_DATA = 'SAVE_BOOKING_TOOL_DATA',
  SAVE_BOOKING_TOOL_DATA_SUCCESS = 'SAVE_BOOKING_TOOL_DATA_SUCCESS',
  GET_BOOKING_TOOL_DATA_BY_SITECODE = 'GET_BOOKING_TOOL_DATA_BY_SITECODE',
  GET_BOOKING_TOOL_DATA_BY_SITECODE_SUCCESS = 'GET_BOOKING_TOOL_DATA_BY_SITECODE_SUCCESS',
  GET_BOOKING_TOOL_DATA_BY_SITECODE_FAIL = 'GET_BOOKING_TOOL_DATA_BY_SITECODE_FAIL'
}
